module.exports = __webpack_public_path__ + "img/b8.e6e9a26e.jpg";